
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    export class DataDictionaryGrid extends Serenity.EntityGrid<DataDictionaryRow, any> {
        protected getColumnsKey() { return 'Data.DataDictionary'; }
        protected getDialogType() { return DataDictionaryDialog; }
        protected getIdProperty() { return DataDictionaryRow.idProperty; }
        protected getLocalTextPrefix() { return DataDictionaryRow.localTextPrefix; }
        protected getService() { return DataDictionaryService.baseUrl; }

        protected getButtons() {
            var buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != 'add-button');
            return buttons;
        }

        constructor(container: JQuery) {
            super(container);
        }
    }
}